import { useMemo } from 'react'
import type {
  EditorialCardItemData,
  EditorialCardsProps,
} from 'src/types/editorialCards2'
import isSafeLink from 'src/utils/isSafeLink'

import EditorialCardItem from './EditorialCardItem'

const REQUIRED_CARDS = 3

const hasText = (value?: string) => Boolean(value?.trim())

const isCardValid = (item?: EditorialCardItemData) => {
  return Boolean(
    hasText(item?.imageSrc) &&
      hasText(item?.imageAlt) &&
      hasText(item?.title) &&
      hasText(item?.ctaText) &&
      isSafeLink(item?.ctaUrl)
  )
}

export default function EditorialCards20({
  isActive,
  cards = [],
}: EditorialCardsProps) {
  const parsedCards = useMemo(() => {
    if (cards.length !== REQUIRED_CARDS) {
      return []
    }

    return cards.every(isCardValid) ? cards : []
  }, [cards])

  if (!isActive || parsedCards.length !== REQUIRED_CARDS) {
    return null
  }

  return (
    <section
      data-testid="editorial-cards-2-0"
      aria-label="Cards de categorias"
      className="w-full pt-8 md:py-12 md:pt-0"
    >
      <div className="mx-auto w-full max-w-[1564px] px-4 md:px-[62px]">
        <div
          data-testid="editorial-cards-grid"
          className="flex flex-col gap-1 md:flex-row md:gap-2 md:h-[600px]"
        >
          {parsedCards.map((item, index) => (
            <EditorialCardItem key={`${item.title}-${index}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  )
}
